module.exports = __webpack_public_path__ + "img/maishaFiti.dbeef081.jpeg";